<template>
  <div class="custom-filter">
    <div class="filter-title">
      <img src="@/assets/icon/filter-icon.svg" />
      <div class="filter-text">Filter</div>
    </div>
    <div v-for="(item, index) in filters" v-bind:key="index">
      <component
        :ref="item"
        :data.sync="internalValue"
        :collectionAddress="collectionAddress"
        v-bind:is="`${item}Filter`"
      />
    </div>
  </div>
</template>

<script>
import {
  ChainsFilter,
  CollectionFilter,
  OfferFilter,
  CurrencyFilter,
  BunicornGamePropertyFilter,
  SellMethodFilter,
  GenresFilter
} from '@/components/Filters';
import config from "@/config";

export default {
  components: {
    ChainsFilter,
    CollectionFilter,
    OfferFilter,
    CurrencyFilter,
    BunicornGamePropertyFilter,
    SellMethodFilter,
    GenresFilter
  },
  props: {
    collectionAddress: {
      type: String,
      default: ''
    },
    filters: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      internalValue: {
        nftContract: '',
        sortByPrice: '',
        sellMethod: '',
        minPrice: '',
        maxPrice: '',
        search: '',
        currency: '',
        attributes: []
      }
    };
  },
  watch: {
    internalValue: {
      handler() {
        this.$emit('input', this.internalValue);
      },
      deep: true
    },
    value: {
      handler() {
        if (JSON.stringify(this.internalValue) !== JSON.stringify(this.value)) {
          this.internalValue = this.value;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    resetGenres() {
      if (this.$refs && this.$refs.genres) {
        this.$refs.genres[0].resetAllFilter();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/config/_variables';

.custom-filter {
  width: 242px;
  min-width: 242px;
  border-radius: 10px;
  border: 1px solid #f3f5fa;
  background-color: #ffffff;
  .filter-title {
    display: flex;
    font-family: Inter-SemiBold;
    font-size: 18px;
    color: #203a54;
    text-transform: uppercase;
    padding: 24px 20px;
    .filter-text {
      margin-left: 8px;
    }
  }
  ::v-deep .filter-collapse {
    border: none;
    .card-header {
      background-color: #ffffff;
      font-family: Inter;
      font-size: 16px;
      color: #203a54;
      padding: 10px 20px;
    }
    &.status {
      .card-body {
        display: flex;
        flex-wrap: wrap;
        div {
          margin: 8px 4px 0 0;
        }
      }
    }
    &.price {
      .price-button-wrapper {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .custom-input {
          width: 54px;
        }
      }
    }
    &.collection {
      .card-body {
        .custom-search-input {
          width: 90%;
          margin: auto;
          input {
            width: 100%;
          }
        }
        .filter-option-btn {
          margin: 4px auto;
          width: 90%;
        }
      }
    }
    &.level {
      .checkbox-grid {
        display: grid;
        grid-template-columns: auto;
      }
    }
    &.on-sale,
    &.properties {
      .checkbox-grid {
        display: grid;
        grid-template-columns: auto auto;
      }
    }
    &.properties {
      .section-subtitle {
        margin-bottom: 4px;
        font-family: Inter-Regular;
        font-size: 16px;
        color: #203a54;
        &.star {
          margin-top: 8px;
        }
      }
    }
    .traittype {
      display: flex;
      flex-wrap: wrap;
      .custom-control {
        flex: 0 0 50%;
        margin-right: 0;
        box-sizing: border-box;
        .custom-control-label {
          font-size: 15px;
        }
      }
    }
  }
}
@media screen and (max-width: $breakpoint-desktop) {
  .custom-filter {
    width: 100%;
    ::v-deep .filter-collapse {
      &.level {
        .checkbox-grid {
          display: grid;
          grid-template-columns: auto auto;
        }
      }
    }
  }
}
</style>
